import type { SurveyAnswerValue } from '@coorum-research/shared-common/types/answer.type'
import type { QuestionImagepickerModelData } from '@coorum-research/shared-common/types/survey-json.type'
import { parseImagepickerAnswer } from '@coorum-research/shared-common/utils/answer.util'

type Props = {
  questionElement: QuestionImagepickerModelData
  answerValue: SurveyAnswerValue
}

export function ImagePickerAnswer({ questionElement, answerValue }: Props) {
  let convertedAnswer: string | string[] | undefined

  if (Array.isArray(answerValue)) {
    convertedAnswer = answerValue.map(String)
  } else if (typeof answerValue === 'string') {
    convertedAnswer = answerValue
  }

  const answer = parseImagepickerAnswer(questionElement, convertedAnswer)
  if (!answer) {
    return null
  }

  const firstChoice = Array.isArray(answer) ? answer[0] : answer
  if (!firstChoice?.imageLink) {
    return <>{firstChoice?.text || ''}</>
  }

  return (
    <div className="flex items-center gap-2">
      <img className="size-10 rounded object-cover" src={firstChoice.imageLink} alt={firstChoice.text || ''} />
      {firstChoice.text && questionElement.showLabel && (
        <span className="truncate text-sm">{firstChoice.text}</span>
      )}
    </div>
  )
}
